import gql from 'graphql-tag';

import CartProductFragment, { ICartProduct } from '../fragments/cart-product.graphql';

export type { ICartProduct } from '../fragments/cart-product.graphql';
export interface IAddToCartData {
  createUpdateCartProduct?: ICartProduct;
}

export default gql`
  mutation addToCart($cartProduct: CreateUpdateCartProductInput!) {
    createUpdateCartProduct(cartProduct: $cartProduct) {
      id
      quantity
      cart {
        id
        cartProducts {
          ...CartProductFragment
        }
      }
    }
  }

  ${CartProductFragment}
`;
